import React, { useEffect, useState } from "react";
import { PiEngineFill } from "react-icons/pi";
import { GrConnect } from "react-icons/gr";
import { GiSpring } from "react-icons/gi";
import { FaDrumSteelpan } from "react-icons/fa6";
import { GiTyre } from "react-icons/gi";
import { FaTachometerAlt } from "react-icons/fa";
import { FaCar } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { GoChecklist } from "react-icons/go";
import { MdOutlineCarCrash } from "react-icons/md";
import { GiCarKey } from "react-icons/gi";
import { BsBank } from "react-icons/bs";
import { FaBook } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import ProgressBar from "react-bootstrap";
import { BsFillLightningFill } from "react-icons/bs";
import { RxCross2 } from "react-icons/rx";
import { IoSettingsOutline } from "react-icons/io5";
import { IoMdPerson } from "react-icons/io";
import { LiaImageSolid } from "react-icons/lia";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Baseurl,Imageurl } from "../../config/BaseUrl";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom/dist";
import { moment } from "moment";
import { useSelector } from "react-redux";
import "react-circular-progressbar/dist/styles.css";
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import RadialSeparators from "./RadialSeparators";
import { PiEngine } from "react-icons/pi";
import { GiGearStick } from "react-icons/gi";
const NewReleaseReport = () => {
  const params = useParams();
  const navigate = useNavigate()
  const { organisationLogo } = useSelector((store) => store.orgLogo);
  const { brandLogo } = useSelector((store) => store.brandLogo);
  const [caseinfo, setcaseinfo] = useState("");
  const [casePerfomanceinfo, setcasePerfomanceinfo] = useState("");
  const [caseEngine, setCaseEngine] = useState("");
  const [caseTransmission, setCaseTransmission] = useState("");
  const [caseSuspension, setCaseSuspension] = useState("");
  const [caseBrakes, setCaseBrakes] = useState("");
  const [caseTyre, setCaseTyre] = useState("");
  const [caseInterior, setCaseInterior] = useState("");
  const [caseExterior, setCaseExterior] = useState("");
  const [caseRating, setCaseRating] = useState("");
  const [temploading, setTempLoading] = useState(false);
  const [percentage, setPercentage] = useState(66);

  //   console.log(casePerfomanceinfo,"1");
  // console.log(casePerfomanceinfo.findBrakesCon,"findBrakesCon");

  const roundImageArray = [
    {
      label: "Poor",
      percentage: 2,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/leg02.png",
    },
    {
      label: "Average",
      percentage: 4,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/leg04.png",
    },
    {
      label: "Satisfactory",
      percentage: 5,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/leg06.png",
    },
    {
      label: "Good",
      percentage: 7,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png",
    },
    {
      label: "Excellent",
      percentage: 9,
      roundImage: "/assets/Adsum Advisory Services Pvt. Ltd._files/leg09.png",
    },
  ];

  useEffect(() => {
    const caseId = params.caseId;
    const fetchData = async () => {
      try {
        const url = `${Baseurl}/api/v1/cases/individualcase/${caseId}`;
        const caseFetch = await axios.get(url);

        try {
          if (caseFetch.data.success) {
            const casedetails = caseFetch.data.case;

            setcaseinfo(casedetails);
            const vehicleType = casedetails.assetType;
            const carCasDetails = casedetails.privateCar;

            let findEngineCon = "";
            let findEVMotorCon = "";
            let findTransmissionCon = "";
            let findSuspensionCon = "";
            let findBrakesCon = "";
            let findTyreCon = "";
            let findInteriorCon = "";
            let findBatteryCon = "";
            let findExteriorCon = "";
            let finalBreakCondition = "";
            let finalTyreCondition = "";

            let transmission = carCasDetails.transmission.transmissionCondition;
            if (vehicleType === "Four Wheeler" || vehicleType === "Car Taxi" || vehicleType === "Motor Cab" || vehicleType === "Four Wheeler EV") {
              findEngineCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.engineCondition
              );
              findEVMotorCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.evMotorCondition
              );
              findTransmissionCon = roundImageArray.find(
                (data) =>
                  data.label ===
                  carCasDetails.transmission.transmissionCondition
              );
              findSuspensionCon = roundImageArray.find(
                (data) =>
                  data.label === carCasDetails.suspension.suspensionCondition
              );
              findInteriorCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.interiorCondition
              );
              findBatteryCon = roundImageArray.find(
                (data) =>
                  data.label === carCasDetails.electricals.battery
              );
              findExteriorCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.exteriorCondition
              );
              const findRareBrakesCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.rearBrakeCondition
              );
              const findFrontBrakesCon = roundImageArray.find(
                (data) =>
                  data.label === casedetails.otherDetails.frontBrakeCondition
              );

              const TotalTyreCon =
                Number(carCasDetails.TyresNConditions.lhRear) +
                Number(carCasDetails.TyresNConditions.lhFront) +
                Number(carCasDetails.TyresNConditions.rhRear) +
                Number(carCasDetails.TyresNConditions.rhfront) +
                Number(carCasDetails.TyresNConditions.spareTyre)

              console.log(TotalTyreCon, "TotalTyreCon");


              findTyreCon = Number(TotalTyreCon) / 50;
              findTyreCon = Math.round(findTyreCon);

              if (findTyreCon === 1 || findTyreCon === 2) {
                finalTyreCondition = 2;
              } else if (findTyreCon === 3 || findTyreCon === 4) {
                finalTyreCondition = 4;
              } else if (findTyreCon === 5 || findTyreCon === 6) {
                finalTyreCondition = 5;
              } else if (findTyreCon === 7 || findTyreCon === 8) {
                finalTyreCondition = 7;
              } else if (findTyreCon === 9 || findTyreCon === 10) {
                finalTyreCondition = 9;
              }


              const totalBrackcon =
                Number(findFrontBrakesCon.percentage) +
                Number(findRareBrakesCon.percentage);
              findBrakesCon = Number(totalBrackcon) / 2;
              findBrakesCon = Math.round(findBrakesCon);

              console.log(4, "4");

              if (findBrakesCon === 1 || findBrakesCon === 2) {
                finalBreakCondition = 2;
              } else if (findBrakesCon === 3 || findBrakesCon === 4) {
                finalBreakCondition = 4;
              } else if (findBrakesCon === 5 || findBrakesCon === 6) {
                finalBreakCondition = 5;
              } else if (findBrakesCon === 7 || findBrakesCon === 8) {
                finalBreakCondition = 7;
              } else if (findBrakesCon === 9 || findBrakesCon === 10) {
                finalBreakCondition = 9;
              }

              console.log(5, "5");

              const findBreakCondition = roundImageArray.find(
                (data) => data.percentage === finalBreakCondition
              );
              const findTyreCondition = roundImageArray.find(
                (data) => data.percentage === finalTyreCondition
              );
let overalRating=0
if(casedetails.assetType==="Four Wheeler EV"){
 overalRating =
                Number(findEVMotorCon.percentage) +
                Number(findTransmissionCon.percentage) +
                Number(findSuspensionCon.percentage) +
                Number(findBatteryCon.percentage) +
                Number(findExteriorCon.percentage) +
                Number(finalBreakCondition) +
                Number(finalTyreCondition);
               const overalavg = Number(overalRating) / 7;
              setcasePerfomanceinfo({
                findEVMotorCon: findEVMotorCon,
                findTransmissionCon: findTransmissionCon,
                findSuspensionCon: findSuspensionCon,
                findBrakesCon: findBreakCondition,
                findTyreCon: findTyreCondition,
                findBatteryCon: findBatteryCon,
                findExteriorCon: findExteriorCon,
                veralrating: overalavg.toFixed(2),
              });
}else{
  overalRating =
                Number(findEngineCon.percentage) +
                Number(findTransmissionCon.percentage) +
                Number(findSuspensionCon.percentage) +
                Number(findInteriorCon.percentage) +
                Number(findExteriorCon.percentage) +
                Number(finalBreakCondition) +
                Number(finalTyreCondition);
              const overalavg = Number(overalRating) / 7;
              setcasePerfomanceinfo({
                findEngineCon: findEngineCon,
                findTransmissionCon: findTransmissionCon,
                findSuspensionCon: findSuspensionCon,
                findBrakesCon: findBreakCondition,
                findTyreCon: findTyreCondition,
                findInteriorCon: findInteriorCon,
                findExteriorCon: findExteriorCon,
                veralrating: overalavg.toFixed(2),
              });
}
              console.log("hii");
            } else {
            }
          }
        } catch (error) { }
      } catch (error) { }
    };
    fetchData();
  }, [params.caseId]);

  return (
    <>
      {caseinfo && casePerfomanceinfo ? (
        <>
          <div >
            <div
              className="content"
              style={{
                border: "1px solid #686868",
                padding: "0 10px",
                width: "100%",
                position: "relative",
              }}
            >
              {/* A4 size */}
              <div className="row noprint p-3">
                <div className="col-sm-6">
                  <a
                    href=""
                    className="btn btn-success"
                    onclick="window.print();"
                  >
                    Print
                  </a>
                </div>
                <div className="col-sm-6 text-right">
                  <a href="" className="btn btn-success">
                    Cancel
                  </a>
                </div>
              </div>
              <div
                className="row"
                style={{
                  padding: "0 15px",
                  fontSize: "12pt",
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className="col-sm-6">
                  Ref. No / Loan No&nbsp;:&nbsp;{caseinfo.loanAgreementNo}
                </div>
                {caseinfo.caseId > 0 && caseinfo.caseId < 10 ? (
                  <>
                    {" "}
                    <div className="col-sm-6 text-right">
                      Case ID&nbsp;:&nbsp;0{caseinfo.caseId}
                    </div>
                  </>
                ) : (
                  <>
                    {" "}
                    <div className="col-sm-6 text-right">
                      Case ID&nbsp;:&nbsp;{caseinfo.caseId}
                    </div>
                  </>
                )}
              </div>

              <div
                style={{
                  padding: "2px 15px",
                  border: "1px solid #000",
                  width: "100%",
                }}
              >
                <div className="row">
                  <div className="col-sm-3 p-2">
                    <img src={organisationLogo} />
                  </div>
                  <div className="col-sm-6 text-center">
                    {/* <br /> */}
                    <h4>
                      <strong>
                        Valuation Report
                        {/* <br /> */}
                        <p>{caseinfo.assetType}</p>
                        {/* <br /> */}
                        <p> <strong>{`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}</strong></p>
                      </strong>
                    </h4>
                    <br />
                    &nbsp;&nbsp;
                  </div>
                  <div className="col-sm-3 text-right">
                    <img src={brandLogo} />
                  </div>
                </div>
              </div>
              <div style={{ padding: "3px 15px" }}>
                <div className="row">
                  <div className="col-sm-7">
                    {/* ==== main col 7*/}
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          // marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 4px",
                        }}
                      >
                        <b style={{ color: "black" }}>     City : {caseinfo.city}</b>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        <b style={{ color: "black" }}>   Color : {caseinfo.vehicleColor}</b>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        <b style={{ color: "black" }}>   Odometer in Kms : {caseinfo.meterReading} </b>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        <b style={{ color: "black" }}>   Fuel Type : {caseinfo.fueltype}</b>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        <b style={{ color: "black" }}>  Transmission :{" "}
                          {caseinfo.additionalFeatures.transmission}</b>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 2,
                          border: "1px solid #000",
                          padding: "3px 5px",
                        }}
                      >
                        <b style={{ color: "black" }}>   Accidental status : {caseinfo.otherDetails.accidental}</b>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 5,
                          padding: "3px 5px",
                          backgroundColor: "#d6d6d6",
                        }}
                      >
                        <span style={{ color: "#000", fontWeight: "bold" }}>
                          <b style={{ color: "black" }}>   Ex. Showroom Price&nbsp;:{caseinfo.marketPrice} </b>
                        </span>
                      </div>
                    </div>
                    <div className="row" style={{ paddingRight: 15 }}>
                      <div
                        className="col-sm-12 newReport"
                        style={{
                          marginTop: 5,
                          padding: "3px 5px",
                          backgroundColor: "#d6d6d6",
                        }}
                      >
                        <span style={{ color: "#000", fontWeight: "bold" }}>
                          <b style={{ color: "black" }}>  Estimated Market Value :{caseinfo.valuation}</b>
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* ==== main col 7 end */}
                  <div className="col-sm-5 text-center imfix">
                    <img
                      src={caseinfo.images.frontImage}
                      className="fixed-img"
                    />
                    {/* <br /> */}
                  </div>
                </div>
              </div>
              {/* ====================================================================== */}
              <div className="row" style={{ padding: ".3px 1px" }}>
                <div
                  className="col-sm-12 newReport"
                  style={{ border: "1px solid #000", borderRadius: 2 }}
                >
                  <table width="100%" style={{ padding: "2px 5px" }}>
                    <tbody>
                      <tr style={{ style: "20px" }}>
                        {
                          caseinfo?.assetType==="Four Wheeler EV"?
                        <td width="12">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={
                                  casePerfomanceinfo.findEVMotorCon.roundImage
                                }
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/engine.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        :
                                                <td width="12">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={
                                  casePerfomanceinfo?.findEngineCon?.roundImage
                                }
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/engine.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        }
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={
                                  casePerfomanceinfo.findTransmissionCon
                                    .roundImage
                                }
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/transm.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer" style={{ overflow: 'hidden' }}>
                              <img
                                src={
                                  casePerfomanceinfo.findSuspensionCon
                                    .roundImage
                                }
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/Suspension.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={
                                  casePerfomanceinfo.findBrakesCon.roundImage
                                }
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/Brakes.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={casePerfomanceinfo.findTyreCon.roundImage}
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/tyres.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                         {
                          caseinfo?.assetType==="Four Wheeler EV"?
                        <td width="12">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={
                                  casePerfomanceinfo.findBatteryCon.roundImage
                                }
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/engine.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        :
                                                <td width="12">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={
                                  casePerfomanceinfo.findInteriorCon.roundImage
                                }
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/engine.png"
                                className="image1"
                                alt="Image 1"
                              />
                            </div>
                          </div>
                        </td>
                        }
                        <td width="12.5%">
                          <div className="center-round">
                            <div className="legcontainer">
                              <img
                                src={casePerfomanceinfo.findExteriorCon.roundImage}
                                alt="Small Image"
                                className="small-image"
                              />
                              <img
                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/Exterior.png"
                                className="image1"
                                alt="Image 1"
                                style={{ height: '28px', width: '30px' }}
                              />
                            </div>
                          </div>
                        </td>
                        <td width="12.5%">
                          {casePerfomanceinfo.veralrating > 0.01 &&
                            casePerfomanceinfo.veralrating < 2 ? (
                            <>
                              <div className="center-round">
                                <div className="legcontainer">
                                  <img
                                    //   src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                    src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg02.png"
                                    alt="Small Image"
                                    className="small-image"
                                  />
                                  <h1
                                    className="image1"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",

                                    }}
                                  >
                                    {casePerfomanceinfo.veralrating}
                                  </h1>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              {casePerfomanceinfo.veralrating > 2.01 &&
                                casePerfomanceinfo.veralrating < 4 ? (
                                <>
                                  <div className="center-round">
                                    <div className="legcontainer">
                                      <img
                                        //   src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                        src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg04.png"
                                        alt="Small Image"
                                        className="small-image"
                                      />
                                      <h1
                                        className="image1"
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",

                                        }}
                                      >
                                        {casePerfomanceinfo.veralrating}
                                      </h1>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  {casePerfomanceinfo.veralrating > 4.01 &&
                                    casePerfomanceinfo.veralrating < 6 ? (
                                    <>
                                      <div className="center-round">
                                        <div className="legcontainer">
                                          <img
                                            //   src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                            src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg06.png"
                                            alt="Small Image"
                                            className="small-image"
                                          />
                                          <div>
                                            <h1
                                              className="image1"
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",

                                              }}
                                            >
                                              {casePerfomanceinfo.veralrating}
                                            </h1>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {casePerfomanceinfo.veralrating > 6.01 &&
                                        casePerfomanceinfo.veralrating < 8 ? (
                                        <>
                                          <div className="center-round">
                                            <div className="legcontainer">
                                              <img
                                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                                // src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg07.png"
                                                alt="Small Image"
                                                className="small-image"
                                              />
                                              <h1
                                                className="image1"
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",

                                                }}
                                              >
                                                {casePerfomanceinfo.veralrating}
                                              </h1>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div className="center-round">
                                            <div className="legcontainer">
                                              <img
                                                //   src="/assets/Adsum Advisory Services Pvt. Ltd._files/ovleg07.png "
                                                src="/assets/Adsum Advisory Services Pvt. Ltd._files/leg09.png"
                                                alt="Small Image"
                                                className="small-image"
                                              />
                                              <h1
                                                className="image1"
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",

                                                }}
                                              >
                                                {casePerfomanceinfo.veralrating}
                                              </h1>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                      <tr className="legtext" style={{ height: "10px" }}>
                        {
                          caseinfo?.assetType==="Four Wheeler EV"?
                        <td>
                          EV Motor
                          {/* <br /> */}
                          <p> {casePerfomanceinfo?.findEVMotorCon?.percentage}/10</p>
                        </td>
                        :
                                                <td>
                          Engine
                          {/* <br /> */}
                          <p> {casePerfomanceinfo.findEngineCon.percentage}/10</p>
                        </td>
                        }
                        <td>
                          Transmission
                          {/* <br /> */}
                          <p> {casePerfomanceinfo.findTransmissionCon.percentage}/10</p>
                        </td>
                        <td>
                          Suspension
                          {/* <br /> */}
                          <p>{casePerfomanceinfo.findSuspensionCon.percentage}/10</p>
                        </td>
                        <td>
                          Brakes
                          {/* <br /> */}
                          <p>{casePerfomanceinfo.findBrakesCon.percentage}/10</p>
                        </td>
                        <td>
                          Tyres
                          {/* <br /> */}
                          <p>{casePerfomanceinfo.findTyreCon.percentage}/10</p>
                        </td>
                        {
                          caseinfo?.assetType==="Four Wheeler EV"?
                        <td>
                         EV Battery
                          {/* <br /> */}
                          <p> {casePerfomanceinfo?.findBatteryCon?.percentage}/10</p>
                        </td>
                        :
                                                     <td>
                          Interior
                          {/* <br /> */}
                          <p> {casePerfomanceinfo.findInteriorCon.percentage}/10</p>
                        </td>
                        }
                        <td>
                          Exterior
                          {/* <br /> */}
                          <p> {casePerfomanceinfo.findExteriorCon.percentage}/10</p>
                        </td>
                        <td>
                          <strong>
                            OVERALL
                            {/* <br /> */}
                            <p> {casePerfomanceinfo.veralrating} of 10</p>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* ====================================================================== */}
              <div className="row">
                <div className="col-sm-12 newReport">
                  <table
                    width="100%"
                    border={1}
                    style={{ fontSize: "10pt", border: "1px solid #688" }}
                  >
                    <tbody>
                      <tr className="p-1" style={{ height: "20px" }}>
                        <td width="75%" rowSpan={2}>
                          &nbsp;&nbsp;&nbsp;&nbsp;Inspection Address
                          {/* <br /> */}
                          &nbsp;&nbsp;&nbsp;&nbsp;{caseinfo.vehicleLocation}
                        </td>
                        <td className="text-center">
                          Created Date
                          {/* <br /> */}
                          {caseinfo.createdAt.slice(0, 10)}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          Service Date
                          {/* <br /> */}
                          {caseinfo.submittedAt.slice(0, 10)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* <div style={{ padding: 8 }} /> */}
              <table>
                <tbody>
                  <tr style={{ height: "20px" }}>
                    <td>
                      <div className="imgcontainer">
                        <img
                          src="/assets/Adsum Advisory Services Pvt. Ltd._files/car01.jpg"
                          className="image3"
                        /> 
                      </div>
                    </td>
                    <td>
                      <strong>&nbsp;&nbsp;VEHICLE DETAILS</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="row">
                <div className="col-sm-12 newReport">
                  {/* *=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*= */}
                  <table width="100%">
                    <tbody>
                      <tr style={{ height: "20px" }}>
                        <td width="24%">
                          <div className="col-sm-12 newReport column-ht">
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car08.jpg"
                              width="auto"
                              height="10%"
                            />
                            {/* <br /> */}
                            <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                              Registration
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}>{caseinfo.regdNo}</p>
                            <hr />
                            <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                              Chasis Number
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}>
                              {caseinfo.chasisNo}
                              {/* <br /> */}
                            </p>
                            <hr />
                            <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                              Engine Number
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}>
                              {caseinfo.engNo}
                              {/* <br /> */}
                            </p>
                            <hr />
                          </div>
                        </td>
                        <td width="24%">
                          <div className="col-sm-12 newReport column-ht">
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car02.jpg"
                              width="auto"
                              height="10%"
                            />
                            {/* <br /> */}
                            <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                              Body Type
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}>
                              {caseinfo.bodyType}
                            </p>
                            <hr />
                            <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                              Manufacture Year
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}>
                              {caseinfo.manufacturingDate}
                            </p>
                            <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                              Date of Registration
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}>
                              {caseinfo.regdDate}
                            </p>
                            <hr />
                            <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                              Vehicle Type
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}>
                              {caseinfo.assetType}
                            </p>
                          </div>
                        </td>
                        <td width="25%">
                          <div className="col-sm-12 newReport column-ht">
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car03.jpg"
                              width="auto"
                              height="10%"
                            />
                            {/* <br /> */}
                            <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                              Owner Name
                            </p>
                            <p style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}>
                              {caseinfo.regdOwner}
                            </p>
                            <hr />
                            <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                              Owner Serial No
                            </p>
                            <p style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}> {caseinfo.ownerSerialNo}</p>
                            <hr />
                            <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                              Proposed Owner Name
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}>{caseinfo.name}</p>
                            <hr />
                            {/* <br /> */}
                          </div>
                        </td>
                        <td width="25%">
                          <div className="col-sm-12 newReport column-ht">
                            <img
                              src="/assets/Adsum Advisory Services Pvt. Ltd._files/car04.jpg"
                              width="auto"
                              height="10%"
                            />
                            {/* <br /> */}
                            <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                              Report Requested by
                            </p>
                            <p style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}>
                              {caseinfo.requesterName}
                            </p>
                            <hr />
                            <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                              Case Type
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}>
                              {caseinfo.caseType}</p>
                            <hr />
                            <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                              Purpose Of Valuation
                            </p>
                            {/* <br /> */}
                            <p style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}>{caseinfo.valuationPurpose}</p>
                            <hr />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {/* *=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*=*= */}
                  {/* <div style={{ padding: 2 }} /> */}
                  <table border={1} width="100%">
                    <tbody>
                      <tr
                        className="text-center"
                        style={{ border: "1px solid black", height: "30px" }}
                      >
                        <td
                          width="50%"
                          style={{ borderRight: "1px solid #686868" }}
                        >
                          <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                            Insurance Company
                          </p>
                          {/* <br /> */}
                          <p style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}>
                            {caseinfo.insuranceCompany}
                          </p>
                        </td>
                        <td width="25%">
                          <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                            Insurance Status
                          </p>
                          {/* <br /> */}
                          <div style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}>
                            {caseinfo.insuranceStatus === "Yes" ? (
                              <p>Expired</p>
                            ) : (
                              <p>Running</p>
                            )}
                          </div>
                        </td>
                        <td style={{ borderLeft: "1px solid #686868" }}>
                          <p style={{ fontSize: '14px', fontWeight: '500', color: '#555' }}>
                            Insurance Valid Till
                          </p>
                          {/* <br /> */}
                          <p style={{ fontSize: '13px', fontWeight: '500', color: '#000' }}>
                            {caseinfo.otherDetails.insuranceExpiry}
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {/* <div style={{ padding: 5 }} /> */}
                  <table width="100%">
                    <tbody>
                      <tr style={{ height: "10px" }}>
                        <td width="65%" style={{ border: "1px solid #686868" }}>
                          <p> &nbsp;&nbsp;Remarks&nbsp;:&nbsp;{caseinfo.yourRemark}</p>
                          <p> &nbsp;&nbsp;Extrior Remarks&nbsp;:&nbsp;{caseinfo.extriorRemark}</p>
                          <a className="ps-2" target="_blank" href={caseinfo.videos} style={{ color: 'blue', textDecoration: 'underline' }}>
                            Preview Video Clip
                          </a>
                          &nbsp;
                          <a style={{ color: 'blue', textDecoration: 'underline' }} target="_blank"
                            //  href={`https://instavalueradmin.netlify.app/imagereport/${caseinfo._id}`}
                            href={caseinfo.imageUrl}
                          // href={`http://localhost:3000/imagereport/${caseinfo._id}`}
                          >
                            Preview Images
                          </a>
                        </td>
                        <td
                          width="35%"
                          rowSpan={2}
                          style={{ border: "1px solid black" }}
                        >
                          <div className="text-center">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src="/assets/stamp.jpeg"
                                width="80px"
                                height="80px"
                              />
                            </div>
                            <div>Authorized Signatory</div>
                            <br />
                          </div>
                        </td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="65%" style={{ border: "1px solid #686868" }}>
                          &nbsp;&nbsp;Field Service By:&nbsp;
                          {caseinfo.fieldServiceBy}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* page footer ends */}
              {/* <div style={{ padding: 5 }} /> */}
            </div>

            <div className="page-break" />
            <div
              className="content"
              style={{
                margin: "20px 0 0 0",
                padding: "0 10px",
                width: "100%",
                border: "1px solid #000",
              }}
            >
              <div style={{ marginTop: 5 }}></div>
              {/*-  header */}
              <div className="row">
                <div className="col-sm-12 newReport">
                  <table
                    className="rcrowheight rtborder"
                    style={{ borderCollapse: "collapse" }}
                    width="100%"
                  >
                    <tbody>
                      <tr style={{ height: "10px" }}>
                        <td>
                          <strong>REGISTRATION DETAILS</strong>
                        </td>
                        <td>
                          <strong>AS PER VAHAN</strong>
                        </td>
                        <td>
                          <strong>AS PER RC</strong>
                        </td>
                        <td>
                          <strong>AS PER ACTUAL</strong>
                        </td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%" style={{ fontSize: '10px', fontWeight: '800' }}>Vehicle Registration No</td>
                        <td>{caseinfo.vehicleEdetails.regNo}</td>
                        <td>{caseinfo.vehicleEdetails.regNo}</td>
                        <td>{caseinfo.regdNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%" style={{ fontSize: '10px', fontWeight: '800' }}>Vehicle Mfg Name </td>
                        <td>{caseinfo.vehicleEdetails.vehicleManufacturerName}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleManufacturerName}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleManufacturerName}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%" style={{ fontSize: '10px', fontWeight: '800' }}>Vehicle Model </td>
                        <td>{caseinfo.vehicleEdetails.model}</td>
                        <td>{caseinfo.vehicleEdetails.model}</td>
                        <td>{caseinfo.vehicleEdetails.model}</td>
                      </tr>
                        {/* <td>{caseinfo.regdNo}</td> */}
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Chasis No&nbsp;:&nbsp;</td>
                        <td style={{ fontSize: '10px', }}>{caseinfo.vehicleEdetails.chassis}</td>
                        <td style={{ fontSize: '10px' }}>{caseinfo.vehicleEdetails.chassis}</td>
                        <td style={{ fontSize: '10px' }}>{caseinfo.chasisNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Engine No&nbsp;:&nbsp;</td>
                        <td> {caseinfo.vehicleEdetails.engine}</td>
                        <td>{caseinfo.vehicleEdetails.engine}</td>
                        <td>{caseinfo.engNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Vehicle Color</td>
                        <td>{caseinfo.vehicleEdetails.vehicleColour}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleColour}</td>
                        <td>{caseinfo.vehicleColor}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Fuel Type&nbsp;:&nbsp;</td>
                        <td>{caseinfo.vehicleEdetails.type}</td>
                        <td>{caseinfo.vehicleEdetails.type}</td>
                        <td>{caseinfo.fueltype}</td>
                      </tr>

                      <tr style={{ height: "10px" }}>
                        <td width="35%">Owner Serial No</td>
                        <td>{caseinfo.vehicleEdetails.ownerCount}</td>
                        <td>{caseinfo.vehicleEdetails.ownerCount}</td>
                        <td>{caseinfo.ownerSerialNo}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Reg Owner Name</td>
                        <td style={{ fontSize: '12px' }}>{caseinfo.vehicleEdetails.owner}</td>
                        <td style={{ fontSize: '12px' }}>{caseinfo.vehicleEdetails.owner}</td>
                        <td style={{ fontSize: '12px' }}>{caseinfo.regdOwner}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%" style={{ fontSize: '10px', fontWeight: '800' }}>Date Of Registration</td>
                        <td> {caseinfo.vehicleEdetails.regDate}</td>
                        <td> {caseinfo.vehicleEdetails.regDate}</td>
                        <td>{caseinfo.regdDate}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">RTA Name</td>
                        <td style={{ fontSize: '12px' }}> {caseinfo.vehicleEdetails.regAuthority}</td>
                        <td style={{ fontSize: '12px' }}> {caseinfo.vehicleEdetails.regAuthority}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%" style={{ fontSize: '10px', fontWeight: '800' }}>Year Of Manufacture</td>
                        <td>{caseinfo.vehicleEdetails.vehicleManufacturingMonthYear}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleManufacturingMonthYear}</td>
                        <td>{caseinfo.manufacturingDate}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%" style={{ fontSize: '10px', fontWeight: '800' }}>Fitness Expiry Date</td>
                        <td>{caseinfo.vehicleEdetails.rcExpiryDate}</td>
                        <td>{caseinfo.vehicleEdetails.rcExpiryDate}</td>
                        <td>{caseinfo.otherDetails.fitnessExpiry}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%" style={{ fontSize: '10px', fontWeight: '800' }}>Insurance Exp Date</td>
                        <td>{caseinfo.vehicleEdetails.vehicleInsuranceUpto}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleInsuranceUpto}</td>
                        <td>{caseinfo.otherDetails.insuranceExpiry}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Tax Valid Up To</td>
                        <td>{caseinfo.vehicleEdetails.vehicleTaxUpto}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleTaxUpto}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Permit Up To</td>
                        <td>{caseinfo.vehicleEdetails.permitValidUpto}</td>
                        <td>{caseinfo.vehicleEdetails.permitValidUpto}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Permit Type</td>
                        <td>{caseinfo.vehicleEdetails.permitType}</td>
                        <td>{caseinfo.vehicleEdetails.permitType}</td>
                        <td>-</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Hypothecation</td>
                        <td>{caseinfo.vehicleEdetails.rcFinancer}</td>
                        <td>{caseinfo.vehicleEdetails.rcFinancer}</td>
                        <td> {caseinfo.hypothecationBank}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Cubic Capacity</td>
                        <td>{caseinfo.vehicleEdetails.vehicleCubicCapacity}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleCubicCapacity}</td>
                        <td>{caseinfo.cubicCapacity}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%" style={{ fontSize: '10px', fontWeight: '800' }}>Gross Vehicle Weight</td>
                        <td>{caseinfo.vehicleEdetails.grossVehicleWeight}</td>
                        <td>{caseinfo.vehicleEdetails.grossVehicleWeight}</td>
                        <td>{caseinfo.vehicleWeight}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Seating Capacity</td>
                        <td> {caseinfo.vehicleEdetails.vehicleSeatCapacity}</td>
                        <td> {caseinfo.vehicleEdetails.vehicleSeatCapacity}</td>
                        <td>{caseinfo.seatingCapacity}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Number Plate</td>
                        <td>{caseinfo.vehicleEdetails.vehicleColour}</td>
                        <td>{caseinfo.vehicleEdetails.vehicleColour}</td>
                        <td>{caseinfo.numberPlate}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Status</td>
                        <td>{caseinfo.vehicleEdetails.status}</td>
                        <td>{caseinfo.vehicleEdetails.status}</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Blacklist Status</td>
                        <td>{caseinfo.vehicleEdetails.blacklistStatus}</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Is Commercial</td>
                        {caseinfo.assetType === "Commercial" ? (
                          <td>Yes</td>
                        ) : (
                          <td>no</td>
                        )}
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Challan Details</td>
                        <td>NA</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="rowheight" width="100%">
                    <tbody>
                      <tr style={{ height: "10px" }}>
                        <td >
                          <strong>OTHERS:</strong>
                        </td>
                        <td >
                          <strong>REGISTRATION DETAILS</strong>
                        </td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Document :{caseinfo.documentVerification}</td>
                        <td width="35%">Fitness Expiry Date :{caseinfo.otherDetails.fitnessExpiry}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Asset Type :{caseinfo.assetType}</td>
                        <td width="35%">Insurance :{caseinfo.insuranceCompany}</td>
                      </tr>
                      <tr style={{ height: "10px" }}>
                        <td width="35%">Manufacturing Year:{caseinfo.manufacturingDate}</td>
                        <td width="35%">Road Tax Validity Upto :{caseinfo.otherDetails.roadTaxValidity}</td>
                      </tr>
                    </tbody>
                  </table>
                  <h4 style={{ marginTop: "2px" }}>
                    <strong>OTHER DETAILS:</strong>
                  </h4>
                  <table className="rowheight" width="100%">
                    <tbody>
                      <tr>
                        <td width="35%">Fuel Type</td>
                        <td width="30%">{caseinfo.fueltype}</td>
                        <td width="35%">Gross Vehicle Weight</td>
                        <td width="30%">{caseinfo.vehicleWeight}</td>
                      </tr>
                      <tr>
                        <td width="35%">Odormeter Type</td>
                        <td width="30%">
                          {caseinfo.additionalFeatures.odometer}
                        </td>
                        <td width="35%">Cubic Capacity</td>
                        <td width="30%">{caseinfo.cubicCapacity}</td>
                      </tr>
                      <tr>
                        <td width="35%">Vehicle Color</td>
                        <td width="30%">{caseinfo.vehicleColor}</td>
                        <td width="35%">Meter Reading In Km</td>
                        <td width="30%">{caseinfo.meterReading}</td>
                      </tr>
                      <tr>
                        <td width="35%">Number Plate</td>
                        <td width="30%">{caseinfo.numberPlate}</td>
                        <td width="35%">Seating Capacity</td>
                        <td width="30%">{caseinfo.seatingCapacity}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* <div style={{ marginTop: 10 }}>&nbsp;</div> */}
            </div>
            {/* <!-- page 2 ends --> */}

            <div className="page-break" />
            <div
              className="content"
              style={{
                margin: "20px 0 0 0",
                padding: "0 10px",
                width: "100%",
                border: "1px solid #000",
              }}
            >
              {/*-  header */}
              {
                caseinfo?.assetType==="Four Wheeler EV"?
                <>
                              <h4 style={{ marginTop: "1px" }}>
                <strong>EV MOTOR:</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Ev Motor</td>
                    <td width="30%"> {caseinfo.privateCar.evMotor?.motor}</td>
                    <td width="30%">
                      {caseinfo?.privateCar?.evMotor?.motor === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">EV Motor Working Status</td>
                    <td width="30%">{caseinfo.otherDetails.evMotorCondition}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.evMotorCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.evMotorCondition === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.evMotorCondition ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.evMotorCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.evMotorCondition === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Power Converter</td>
                    <td width="30%"> {caseinfo?.privateCar?.evMotor?.powerConverter}</td>
                    <td width="30%">
                      {caseinfo?.privateCar?.evMotor?.powerConverter === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Shaft Motor</td>
                    <td width="30%">
                      {caseinfo.privateCar.evMotor.shaftMotor}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.evMotor.shaftMotor === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.evMotor.shaftMotor === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.evMotor.shaftMotor ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.evMotor.shaftMotor === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.evMotor.shaftMotor ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
                </>
                :<>
                              <h4 style={{ marginTop: "1px" }}>
                <strong>ENGINE:</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Engine</td>
                    <td width="30%"> {caseinfo.privateCar.engine.engine}</td>
                    <td width="30%">
                      {caseinfo.privateCar.engine.engine === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Engine Condition</td>
                    <td width="30%">{caseinfo.otherDetails.engineCondition}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.engineCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.engineCondition === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.engineCondition ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.engineCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.engineCondition === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Fluid Leaks</td>
                    <td width="30%"> {caseinfo.privateCar.engine.fluidLeak}</td>
                    <td width="30%">
                      {caseinfo.privateCar.engine.fluidLeak === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Engine Shield</td>
                    <td width="30%">
                      {caseinfo.privateCar.engine.engineShield}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.engine.engineShield === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.engine.engineShield === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.engine.engineShield ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.engine.engineShield === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.engine.engineShield ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
                </>
              }
              <h4 style={{ marginTop: "1px" }}>
                <strong>TRANSMISSION:</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Transmission Type</td>
                    <td width="30%">
                      {caseinfo.additionalFeatures.transmission}
                    </td>
                    <td width="30%">
                      <span>&nbsp;</span>
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%"> Transmission Condition</td>
                    <td width="30%">
                      {caseinfo.privateCar.transmission.transmissionCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.transmission
                        .transmissionCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.transmission
                        .transmissionCondition === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.transmission
                        .transmissionCondition === "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.transmission
                        .transmissionCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.transmission
                        .transmissionCondition === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "1px" }}>
                <strong>SUSPENSION</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Suspension Condition</td>
                    <td width="30%">
                      {caseinfo.privateCar.suspension.suspensionCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.suspension.suspensionCondition ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.suspension.suspensionCondition ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.suspension.suspensionCondition ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.suspension.suspensionCondition ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.suspension.suspensionCondition ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "1px" }}>
                <strong>BRAKES</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Front Brake Condition</td>
                    <td width="30%">
                      {caseinfo.otherDetails.frontBrakeCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.otherDetails.frontBrakeCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontBrakeCondition ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontBrakeCondition ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontBrakeCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontBrakeCondition ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Rear Brake Condition</td>
                    <td width="30%">
                      {caseinfo.otherDetails.rearBrakeCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.otherDetails.rearBrakeCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearBrakeCondition ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearBrakeCondition ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearBrakeCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearBrakeCondition ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Hand Brake</td>
                    <td width="30%">{caseinfo.privateCar.brakes.handBrake}</td>
                    <td width="30%">
                      {caseinfo.privateCar.brakes.handBrake === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.brakes.handBrake === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.brakes.handBrake ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.brakes.handBrake === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.brakes.handBrake === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "1px" }}>
                <strong>WHEELS</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Wheel Type</td>
                    <td width="30%"> {caseinfo.otherDetails.wheelsType}</td>
                    <td width="30%">---</td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "1px" }}>
                <strong>TYRES CONDITION</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Type</td>
                    <td width="30%">
                      {caseinfo.privateCar.TyresNConditions.type}
                    </td>
                    <td width="30%"></td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Lh Front</td>
                    <td width="30%">
                      {caseinfo.privateCar.TyresNConditions.lhFront}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.TyresNConditions.lhFront >= "0" &&
                        caseinfo.privateCar.TyresNConditions.lhFront <= 20 ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.lhFront >=
                        "20.01" &&
                        caseinfo.privateCar.TyresNConditions.lhFront <= "40" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.lhFront >=
                        "40.01" &&
                        caseinfo.privateCar.TyresNConditions.lhFront <= "60" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.lhFront >=
                        "60.01" &&
                        caseinfo.privateCar.TyresNConditions.lhFront <= "80" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.lhFront >=
                        "80.01" &&
                        caseinfo.privateCar.TyresNConditions.lhFront <= "100" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Rh Front</td>
                    <td width="30%">
                      {caseinfo.privateCar.TyresNConditions.rhfront}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.TyresNConditions.rhfront >= "0" &&
                        caseinfo.privateCar.TyresNConditions.rhfront <= 20 ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.rhfront >=
                        "20.01" &&
                        caseinfo.privateCar.TyresNConditions.rhfront <= "40" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.rhfront >=
                        "40.01" &&
                        caseinfo.privateCar.TyresNConditions.rhfront <= "60" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.rhfront >=
                        "60.01" &&
                        caseinfo.privateCar.TyresNConditions.rhfront <= "80" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.rhfront >=
                        "80.01" &&
                        caseinfo.privateCar.TyresNConditions.rhfront <= "100" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Lh Rear</td>
                    <td width="30%">
                      {caseinfo.privateCar.TyresNConditions.lhRear}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.TyresNConditions.lhRear >= "0" &&
                        caseinfo.privateCar.TyresNConditions.lhRear <= 20 ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.lhRear >= "20.01" &&
                        caseinfo.privateCar.TyresNConditions.lhRear <= "40" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.lhRear >= "40.01" &&
                        caseinfo.privateCar.TyresNConditions.lhRear <= "60" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.lhRear >= "60.01" &&
                        caseinfo.privateCar.TyresNConditions.lhRear <= "80" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.lhRear >= "80.01" &&
                        caseinfo.privateCar.TyresNConditions.lhRear <= "100" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Rh Rear</td>
                    <td width="30%">
                      {caseinfo.privateCar.TyresNConditions.rhRear}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.TyresNConditions.rhRear >= "0" &&
                        caseinfo.privateCar.TyresNConditions.rhRear <= 20 ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.rhRear >= "20.01" &&
                        caseinfo.privateCar.TyresNConditions.rhRear <= "40" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.rhRear >= "40.01" &&
                        caseinfo.privateCar.TyresNConditions.rhRear <= "60" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.rhRear >= "60.01" &&
                        caseinfo.privateCar.TyresNConditions.rhRear <= "80" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.TyresNConditions.rhRear >= "80.01" &&
                        caseinfo.privateCar.TyresNConditions.rhRear <= "100" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  {caseinfo.otherDetails.spareTyre > "0" ? (
                    <tr style={{ height: "8px" }}>
                      <td width="35%">Spare</td>
                      <td width="30%">
                        {caseinfo.privateCar.TyresNConditions.spareTyre}
                      </td>
                      <td width="30%">
                        {caseinfo.privateCar.TyresNConditions.spareTyre >=
                          "0" &&
                          caseinfo.privateCar.TyresNConditions.rhRear <= 20 ? (
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                        ) : (
                          <></>
                        )}
                        {caseinfo.privateCar.TyresNConditions.spareTyre >=
                          "20.01" &&
                          caseinfo.privateCar.TyresNConditions.spareTyre <= "40" ? (
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                        ) : (
                          <></>
                        )}
                        {caseinfo.privateCar.TyresNConditions.spareTyre >=
                          "40.01" &&
                          caseinfo.privateCar.TyresNConditions.spareTyre <= "60" ? (
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                        ) : (
                          <></>
                        )}
                        {caseinfo.privateCar.TyresNConditions.spareTyre >=
                          "60.01" &&
                          caseinfo.privateCar.TyresNConditions.spareTyre <= "80" ? (
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                        ) : (
                          <></>
                        )}
                        {caseinfo.privateCar.TyresNConditions.spareTyre >=
                          "80.01" &&
                          caseinfo.privateCar.TyresNConditions.spareTyre <= "100" ? (
                          <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                        ) : (
                          <></>
                        )}
                      </td>
                    </tr>
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Total Tyres Ex Spare</td>
                    <td width="30%">{caseinfo.otherDetails.totalTyre}</td>
                    <td width="30%">-</td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Available Tyres</td>
                    <td width="30%">{caseinfo.otherDetails.availableTyre}</td>
                    <td width="30%">-</td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Missing Tyres</td>
                    <td width="30%">{caseinfo.otherDetails.missingTyre}</td>
                    <td width="30%">-</td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Spare Tyre</td>
                    <td width="30%">{caseinfo.otherDetails.spareTyre}</td>
                    <td width="30%">-</td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "1px" }}>
                <strong>ELECTRICALS:</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Battery Condition</td>
                    <td width="30%">
                      {caseinfo.privateCar.electricals.battery}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.electricals.battery === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.electricals.battery === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.electricals.battery ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.electricals.battery === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.electricals.battery ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Instrument Cluster</td>
                    <td width="30%">
                      {caseinfo.privateCar.electricals.instrumentClustor}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.electricals.instrumentClustor ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.electricals.instrumentClustor ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.electricals.instrumentClustor ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.electricals.instrumentClustor ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.electricals.instrumentClustor ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">HeadLamp</td>
                    <td width="30%">{caseinfo.otherDetails.headLamp}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.headLamp === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.headLamp === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.headLamp === "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.headLamp === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.headLamp === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">TailLamp</td>
                    <td width="30%">{caseinfo.otherDetails.tailLamp}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.tailLamp === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.tailLamp === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.tailLamp === "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.tailLamp === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.tailLamp === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Front Indicators</td>
                    <td width="30%">{caseinfo.otherDetails.frontIndicators}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.frontIndicators === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontIndicators === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontIndicators ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontIndicators === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.frontIndicators === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Rear Indicators</td>
                    <td width="30%">{caseinfo.otherDetails.rearIndicators}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.rearIndicators === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearIndicators === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearIndicators ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearIndicators === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.rearIndicators === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Fog Lamps</td>
                    <td width="30%">
                      {caseinfo.privateCar.electricals.fogLamps}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.electricals.fogLamps === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Fog Lamps Condition</td>
                    <td width="30%">
                      {caseinfo.privateCar.electricals.fogLampCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.electricals.fogLampCondition ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.electricals.fogLampCondition ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.electricals.fogLampCondition ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.electricals.fogLampCondition ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.electricals.fogLampCondition ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              {/* <div className="row">
                <div className="col-sm-12 newReport">
                  <div
                    style={{
                      padding: 2,
                      border: "1px solid #000",
                      width: "100%",
                    }}
                  >
                 
                    <div className="col-sm-12 newReport text-center">
                      <strong>Head Office:</strong>
                      <br />
                      J15-A, LANE NO-40, RAJAPURI,J15-UTTAM NAGAR,DELHI, 110059
                      <br />
                      Phone: 9866773092 | Email: pankaj623@gmail.com | Website:
                      https://www.adsum.co.in
                    </div>
                  </div>
                </div>
              
              </div> */}
              {/* <div style={{ marginTop: 10 }}>&nbsp;</div> */}
            </div>
            {/* <!-- page 3 ends --> */}

            <div className="page-break" />
            <div
              className="content"
              style={{
                margin: "30px 0 0 0",
                padding: "0 8px",
                width: "100%",
                border: "2px solid #000",
              }}
            >
              {/*-  header */}
              <h4 style={{ marginTop: "1px" }}>
                <strong>VEHICLE INTERIOR:</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Steering</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.steering}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.steering ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.steering ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.steering ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.steering ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.steering ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Steering Condition</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.steeringCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.steeringCondition ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.steeringCondition ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.steeringCondition ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.steeringCondition ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.steering ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Air Conditioner</td>
                    <td width="30%"> {caseinfo.accessories.ac}</td>
                    <td width="30%">
                      {caseinfo.accessories.ac === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Dashboard</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.dashboard}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.dashboard ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.dashboard ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.dashboard ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.dashboard ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.dashboard ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Seats</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.seats}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.seats === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.seats ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.seats ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.seats === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.seats ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Interior Trims</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.interiorsTrims}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.interiorsTrims ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.interiorsTrims ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.interiorsTrims ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.interiorsTrims ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleInterior.interiorsTrims ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">AirBag</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.airBag}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.airBag === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">
                      Anti-lock Braking  System (ABS)
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.antilockBrakeSystem}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior
                        .antilockBrakeSystem === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Power Window Front</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.powerWindowFront}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.powerWindowFront ===
                        "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Power Window Rear</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.powerWindowRear}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.powerWindowRear ===
                        "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Seat Belts</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.seatBelts}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.seatBelts ===
                        "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">
                      Inside Rear View  Mirror (IRVM)
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior.insideRearViewMirror}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleInterior
                        .insideRearViewMirror === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "1px" }}>
                <strong>VEHICLE EXTERIOR</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Bonnet</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.bonnet}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.bonnet === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.bonnet ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.bonnet ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.bonnet === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.bonnet ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Front Bumper</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.frontBumper}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.frontBumper ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.frontBumper ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.frontBumper ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.frontBumper ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.frontBumper ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Rear Bumper</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.rearBumper}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.rearBumper ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.rearBumper ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.rearBumper ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.rearBumper ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.rearBumper ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Windscreen</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.windScreen}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.windScreen ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.windScreen ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.windScreen ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.windScreen ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.windScreen ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Windscreen Glass</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.windscreenGlass}
                    </td>
                    <td width="30%"></td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">RearWindScreen</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.rearWindScreen}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.rearWindScreen ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.rearWindScreen ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.rearWindScreen ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.rearWindScreen ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.rearWindScreen ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">RhSideBody</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.rhSideBody}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.rhSideBody ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.rhSideBody ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.rhSideBody ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.rhSideBody ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.rhSideBody ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">LhSideBody</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.lhSideBody}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.lhSideBody ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.lhSideBody ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.lhSideBody ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.lhSideBody ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.lhSideBody ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">LhDoorGlasses</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.lhDoorGlasses}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.lhDoorGlasses ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.lhDoorGlasses ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.lhDoorGlasses ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.lhDoorGlasses ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.lhDoorGlasses ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">OutsideRearViewMirror</td>
                    <td width="30%">
                      {
                        caseinfo.privateCar.vehicleExterior
                          .outsideRearViewMirror
                      }
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior
                        .outsideRearViewMirror === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior
                        .outsideRearViewMirror === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior
                        .outsideRearViewMirror === "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior
                        .outsideRearViewMirror === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior
                        .outsideRearViewMirror === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">Paint</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.paint}
                    </td>
                    <td width="30%"></td>
                  </tr>
                  <tr style={{ height: "10px" }}>
                    <td width="35%">paintCondition</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.paintCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.paintCondition ===
                        "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.paintCondition ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.paintCondition ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.paintCondition ===
                        "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior.paintCondition ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">OverallBodyCondition</td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior.overallBodyCondition}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.vehicleExterior
                        .overallBodyCondition === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior
                        .overallBodyCondition === "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior
                        .overallBodyCondition === "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior
                        .overallBodyCondition === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.privateCar.vehicleExterior
                        .overallBodyCondition === "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "1px" }}>
                <strong>ACCESSORIES(IF ANY)</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Sunroof</td>
                    <td width="30%">
                      {caseinfo.privateCar.accessories.sunroof}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.accessories.sunroof === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">MusicSystem</td>
                    <td width="30%">
                      {caseinfo.privateCar.accessories.musicStytem}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.accessories.musicStytem === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">RoofRails</td>
                    <td width="30%">
                      {caseinfo.privateCar.accessories.roofRails}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.accessories.roofRails === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">SeatCovers</td>
                    <td width="30%">
                      {caseinfo.accessories.seatCover}
                    </td>
                    <td width="30%">
                      {caseinfo.accessories.seatCover === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Antenna</td>
                    <td width="30%">
                      {caseinfo.privateCar.accessories.antenna}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.accessories.antenna === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Reverse Camera</td>
                    <td width="30%">
                      {caseinfo.privateCar.accessories.reverseCamera}
                    </td>
                    <td width="30%">
                      {caseinfo.privateCar.accessories.reverseCamera ===
                        "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ marginTop: "1px" }}>
                <strong>ADDITIONAL DETAILS:</strong>
              </h4>
              <table className="rowheight" width="100%">
                <tbody>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Whether Accidental</td>
                    <td width="30%">{caseinfo.otherDetails.accidental}</td>
                    <td width="30%">
                      {caseinfo.otherDetails.accidental === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Level Of Maintenance</td>
                    <td width="30%">
                      {caseinfo.otherDetails.levelOfMaintenance}
                    </td>
                    <td width="30%">
                      {caseinfo.otherDetails.levelOfMaintenance === "Poor" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lpoor.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.levelOfMaintenance ===
                        "Average" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lave.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.levelOfMaintenance ===
                        "Satisfactory" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lsati.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.levelOfMaintenance === "Good" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lgood.png" />
                      ) : (
                        <></>
                      )}
                      {caseinfo.otherDetails.levelOfMaintenance ===
                        "Excellent" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/lexcel.png" />
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr style={{ height: "8px" }}>
                    <td width="35%">Other Repairs If Any</td>
                    <td width="30%">{caseinfo.otherDetails.otherRepair}</td>
                    <td width="30%">
                      {caseinfo.privateCar.accessories.otherRepair === "Yes" ? (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/right.jpg" />
                      ) : (
                        <img src="/assets/Adsum Advisory Services Pvt. Ltd._files/wrong.jpg" />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* <!-- page 4 ends --> */}
            <div className="page-break" />
            <div style={{ marginTop: 10 }}>&nbsp;</div>
            <div
              style={{
                padding: "2px 25px",
                border: "1px solid #000",
                width: "100%",
              }}
            >
              <div className="row">
                <div className="col-sm-3 p-2">
                  <img src={organisationLogo} />
                </div>
                <div className="col-sm-6 text-center">
                  <br />
                  <h4>
                    <strong>
                      Valuation Report
                      <br />
                      {caseinfo.assetType}
                      <br />
                      {`${caseinfo.brand} ${caseinfo.model} ${caseinfo.variant}`}
                    </strong>
                  </h4>
                  &nbsp;
                </div>
                <div className="col-sm-3 text-right">
                  <img src={brandLogo} />
                </div>
              </div>
            </div>
            {/*-  header */}

            {/*- content border */}
            <h4>
              <strong>
                IMAGES:
              </strong>
            </h4>
            <div className="row">
              <div className="col-sm-12 newReport">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                  {
                    Object.keys(caseinfo.images).map((key) => {
                      if (key === 'selfieWithVehicle' && caseinfo.images[key] !== "") {
                        return (
                          <span key={key} style={{ width: '45%', margin: '10px' }}>
                            <a target="_blank" href={caseinfo.images.selfieWithVehicle}>
                              <div style={{ position: "relative" }}>
                                <img
                                  src={caseinfo.images.selfieWithVehicle}
                                  style={{ height: "250px", width: "100%" }}
                                  alt="Selfie with Vehicle"
                                />
                                <img
                                  src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                                  className="small-logo"
                                  width="75px"
                                  height="53px"
                                  alt="Side Logo"
                                />
                              </div>
                            </a>
                          </span>
                        );
                      }
                      return null;
                    })
                  }
                  {
                    Object.keys(caseinfo.images).map((key) => {
                      if (key === 'frontImage' && caseinfo.images[key] !== "") {
                        return (
                          <span key={key} style={{ width: '45%', margin: '10px' }}>
                            <a key={key} target="_blank" href={caseinfo.images.frontImage}>
                              <div style={{ position: "relative" }}>
                                <img
                                  src={caseinfo.images.frontImage}
                                  style={{ height: "250px", width: "420px" }}
                                  alt="Front Image"
                                />
                                <img
                                  src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                                  className="small-logo"
                                  width="75px"
                                  height="53px"
                                  alt="Side Logo"
                                />
                              </div>
                            </a>
                          </span>
                        );
                      }
                      return null;
                    })
                  }
                  {
                    Object.keys(caseinfo.images).map((key) => {
                      if (key !== 'selfieWithVehicle' && key !== 'frontImage' && caseinfo.images[key] !== "") {
                        return (
                          <span key={key} style={{ width: '45%', margin: '10px' }}>
                            <a key={key} target="_blank" href={caseinfo.images[key]}>
                              <div style={{ position: "relative" }}>
                                <img
                                  src={caseinfo.images[key]}
                                  style={{ height: "250px", width: "420px" }}
                                  alt="Other Images"
                                />
                                <img
                                  src="/assets/Adsum Advisory Services Pvt. Ltd._files/sidelogo.png"
                                  className="small-logo"
                                  width="75px"
                                  height="53px"
                                  alt="Side Logo"
                                />
                              </div>
                            </a>
                          </span>
                        );
                      }
                      return null;
                    })
                  }
                </div>
                <div className="row">
                  <div className="col-sm-12 newReport">
                    <div
                      style={{
                        padding: "15px 10px",
                        border: "1px solid #686868",
                      }}
                    >
                      Disclaimer:
                      <br />
                      o This report is issued without prejudice
                      <br />
                      o The valuation has been done based on the superficial
                      examination of vehicle condition and the doeuments
                      provided at the time of inspection.
                      <br />
                      o This report is valid for the date of inspection and time
                      only
                      <br />
                      o This valuation has been performed to the best of our
                      ability and our responsibility is limited to proven
                      negligence.
                      <br />
                      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', paddingRight: '20px' }}>
                        <img
                          src="/assets/stamp.jpeg"
                          width="80px"
                          height="80px"
                        />
                      </div>
                      <div className="text-right">
                        <p>
                          Authorized Signatory
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: 3 }}>&nbsp;</div>
                <div className="row">
                  <div className="col-sm-12 newReport">
                    <div
                      style={{
                        padding: 2,
                        border: "1px solid #000",
                        width: "100%",
                      }}
                    >
                      {/* page footer */}
                      <div className="col-sm-12 newReport text-center">
                        <strong>Head Office:</strong>
                        <br />
                        Door No. 411,4th Floor, Eden Amsri Square,beside Apollo
                        Hospital, Sangeet Circle,
                        <br />
                        Secunderabad 500003, Telengana
                      </div>
                    </div>
                  </div>
                  {/* page footer ends */}
                </div>
              </div>
            </div>
            <br />
            {/* /div> <!-- A4 size */}
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default NewReleaseReport;
